import React from 'react'
import { FiBox, FiLock, FiShield } from 'react-icons/fi'
import { FaTruck, FaTruckMoving, FaTruckPickup } from 'react-icons/fa'
import publicidad3 from '../../assets/images/examples/publicidad3.png'

export const categories = [
  { label: 'Caja 40', icon: <FiBox /> },
  { label: 'Caja 48', icon: <FiBox /> },
  { label: 'Caja 53', icon: <FiBox /> },
  { label: 'Sencillo', icon: <FaTruck /> },
  { label: 'Full', icon: <FaTruckMoving /> },
  { label: 'Lowboy', icon: <FaTruckPickup /> },
  { label: 'Sellos', icon: <FiLock /> },
  { label: 'Custodia', icon: <FiShield /> }
]

export const ciudades = [
  {
    name: 'Manzanillo',
    img: 'https://images.unsplash.com/photo-1728957832168-ba415d9df12e?auto=format&fit=crop&w=800&q=80'
  },
  {
    name: 'Veracruz',
    img: 'https://images.unsplash.com/photo-1562892302-97faedd66f1c?auto=format&fit=crop&w=800&q=80'
  },
  {
    name: 'Ciudad de México',
    img: 'https://images.unsplash.com/photo-1682916114863-ba2f7b7d39c9?auto=format&fit=crop&w=800&q=80'
  },
  {
    name: 'Monterrey',
    img: 'https://plus.unsplash.com/premium_photo-1697730087204-be50f1d852cb?auto=format&fit=crop&w=800&q=80'
  },
  {
    name: 'Lázaro Cárdenas',
    img: 'https://images.unsplash.com/photo-1591907303049-a5e5df26bcb9?auto=format&fit=crop&w=800&q=80'
  },
  {
    name: 'Altamira',
    img: 'https://images.unsplash.com/photo-1564035105550-e1f02aa8556b?auto=format&fit=crop&w=800&q=80'
  }
]

export const tendencias = [
  {
    nombre: 'TransLogix',
    desc: 'Tu aliado logístico especializado en contenedores marítimos.',
    ubic: 'Veracruz',
    precio: '$39,000 MXN',
    dest: false,
    img: 'https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?auto=format&fit=crop&w=900&q=80'
  },
  {
    nombre: 'RápidoMove',
    desc: 'Entrega exprés garantizada para rutas urgentes.',
    ubic: 'Manzanillo',
    precio: '$38,000 MXN',
    dest: true,
    img: 'https://images.unsplash.com/photo-1651928977880-ffb2d963b6b4?auto=format&fit=crop&w=900&q=80'
  },
  {
    nombre: 'ViaExpress',
    desc: 'Servicio premium de temperatura controlada.',
    ubic: 'Ciudad de México',
    precio: '$41,000 MXN',
    dest: true,
    img: 'https://images.unsplash.com/photo-1651928977880-ffb2d963b6b4?auto=format&fit=crop&w=900&q=80'
  },
  {
    nombre: 'CargoLink',
    desc: 'Conectamos tu carga con cobertura nacional.',
    ubic: 'Guadalajara',
    precio: '$45,000 MXN',
    dest: false,
    img: 'https://images.unsplash.com/photo-1675889335425-a4af2d00154d?auto=format&fit=crop&w=900&q=80'
  },
  {
    nombre: 'TorquePrime',
    desc: 'Rutas industriales con escoltas y tracking satelital.',
    ubic: 'Saltillo',
    precio: '$46,500 MXN',
    dest: true,
    img: 'https://images.unsplash.com/photo-1502877338535-766e1452684a?auto=format&fit=crop&w=900&q=80'
  },
  {
    nombre: 'FreshChain',
    desc: 'Cadena fría certificada para alimentos y farmacéuticos.',
    ubic: 'Mexicali',
    precio: '$52,800 MXN',
    dest: false,
    img: 'https://images.unsplash.com/photo-1501706362039-c06b2d715385?auto=format&fit=crop&w=900&q=80'
  },
  {
    nombre: 'PortMaster',
    desc: 'Operaciones intermodales puerto-aduana con visibilidad 24/7.',
    ubic: 'Lázaro Cárdenas',
    precio: '$49,400 MXN',
    dest: true,
    img: publicidad3
  },
  {
    nombre: 'GreenHaul',
    desc: 'Transporte sustentable con unidades Euro V y VI.',
    ubic: 'Querétaro',
    precio: '$36,900 MXN',
    dest: false,
    img: '/Banner1.png'
  }
]

export const unidades = [
  { tipo: 'Caja 53', img: '/Images/Caja53.png' },
  { tipo: 'Caja 48', img: '/Images/Caja48.png' },
  { tipo: 'Full', img: '/Images/Full.png' },
  { tipo: '3.5 Ton', img: '/Images/3.5ton.png' },
  { tipo: 'Rabon', img: '/Images/Rabon.jpg' },
  { tipo: 'Proyecto', img: '/Images/Proyecto.png' },
  { tipo: 'Pallet', img: '/Images/Pallet.png' },
  { tipo: 'Grua', img: '/Images/Grua.png' },
  { tipo: 'Etiquetas IMO', img: '/Images/EtiquetasIMO.png' },
  { tipo: 'Sellos', img: '/Images/Sellos.png' },
  { tipo: 'Custodia', img: '/Images/Custodia.png' },
  { tipo: 'Embalaje', img: '/Images/Embalaje.png' }
]

export const publicacionesRecientes = [
  {
    titulo: 'Caja seca 53 pie',
    ubic: 'San Luis Potosí -> Monterrey',
    precio: '$22,500 MXN',
    img: 'https://images.unsplash.com/photo-1655720055176-f1797242bde2?auto=format&fit=crop&w=900&q=80',
    href: '/marketplace'
  },
  {
    titulo: 'Lowboy extendible',
    ubic: 'Querétaro -> Saltillo',
    precio: '$36,000 MXN',
    img: 'https://images.unsplash.com/photo-1568600891621-2ed6c0c64598?auto=format&fit=crop&w=900&q=80',
    href: '/marketplace'
  },
  {
    titulo: 'Refrigerado 3.5 tons',
    ubic: 'CDMX -> Guadalajara',
    precio: '$18,900 MXN',
    img: 'https://images.unsplash.com/photo-1611095788110-0bd2566b04cf?auto=format&fit=crop&w=900&q=80',
    href: '/marketplace'
  },
  {
    titulo: 'Full platform',
    ubic: 'Lázaro Cárdenas -> Puebla',
    precio: '$44,700 MXN',
    img: 'https://images.unsplash.com/photo-1503376780353-7e6692767b70?auto=format&fit=crop&w=900&q=80',
    href: '/marketplace'
  }
]

export const proveedores = [
  {
    nombre: 'LogiFlow',
    ubi: 'Ciudad de México, MX',
    desc: 'Especialistas en rutas nacionales y última milla segura.',
    rating: 4.9,
    dest: true,
    img: '/Placeholder1.png'
  },
  {
    nombre: 'ViaExpress',
    ubi: 'Monterrey, MX',
    desc: 'Cobertura premium con monitoreo en cabina.',
    rating: 4.8,
    dest: false,
    img: '/Placeholder2.png'
  },
  {
    nombre: 'GlobalTransit',
    ubi: 'Los Ángeles, US',
    desc: 'Conectividad transfronteriza y despacho aduanal.',
    rating: 4.7,
    dest: true,
    img: '/Placeholder3.png'
  },
  {
    nombre: 'SecureHaul',
    ubi: 'Miami, US',
    desc: 'Cadena fría certificada y vigilancia 24/7.',
    rating: 4.8,
    dest: false,
    img: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=900&q=80'
  },
  {
    nombre: 'CargoMax',
    ubi: 'Houston, US',
    desc: 'Máxima capacidad para proyectos industriales.',
    rating: 4.6,
    dest: false,
    img: 'https://images.unsplash.com/photo-1604719312566-8912e9227c6a?auto=format&fit=crop&w=900&q=80'
  },
  {
    nombre: 'TransExpress',
    ubi: 'Guadalajara, MX',
    desc: 'Entrega puntual con reporteo operativo en tiempo real.',
    rating: 4.7,
    dest: true,
    img: 'https://images.unsplash.com/photo-1610373550610-26931618a923?auto=format&fit=crop&w=900&q=80'
  }
]
